import css from "./SkillList.module.css";

export function SkillList() {
  return (
    <div>
      <ul>
        <li>1</li>
      </ul>
    </div>
  );
}
